export default function Node_Path() {
  return <div>Node_Path Component</div>;
}
